import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { MaalerTypeRepository } from "../maaler-type/maaler-type.repository";
import { findMaalerType } from "../maaler-type/maaler-type.util";
import { InstallationMaalerAflaesningRepository } from "./installation-maaler-aflaesning.repository";
import { InstallationMaalerAflaesning, InstallationMaalerAflaesningMedMaalerType } from "./model/installation-maaler-aflaesning.model";

@Injectable({ providedIn: "root" })
export class InstallationMaalerAflaesningService {
    constructor(
        private readonly maalerAflaesningRepository: InstallationMaalerAflaesningRepository,
        private readonly maalerTypeRepository: MaalerTypeRepository
    ) {}

    public hentMaalerAflaesningForAktuelleInstallation(): Observable<InstallationMaalerAflaesningMedMaalerType> {
        const maalerAflaesning$ = this.maalerAflaesningRepository.hentMaalerAflaesningForAktuelleInstallation();
        const maalerTyper$ = this.maalerTypeRepository.hentMaalerTyper();
        return combineLatest([maalerAflaesning$, maalerTyper$]).pipe(
            map(([maalerAflaesning, maalerTyper]) => ({
                ...maalerAflaesning,
                maalerType: findMaalerType(maalerAflaesning.aflaesning, maalerTyper)
            }))
        );
    }

    public gemMaalerAflaesning(maalerAflaesning: InstallationMaalerAflaesning): Promise<void> {
        return this.maalerAflaesningRepository.gemMaalerAflaesning(maalerAflaesning);
    }
}
